module.exports = __webpack_public_path__ + "static/media/home-handle-picture.e9dc8b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-handle-picture.jpg
// module id = 2680
// module chunks = 0